import { css } from '@emotion/core'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import QuoteIcon from '../icons/abstract/quote.svg'
import RichTextAssetBlock from './content-management/RichTextAssetBlock'

interface TestimonialQuoteProps {
  className?: string
  name: string
  position: string
  quote: string
  avatarSrc?: { gatsbyImageData: IGatsbyImageData }
  avatarAlt: string
}

export const TestimonialQuote: React.FunctionComponent<TestimonialQuoteProps> = ({
  className,
  name,
  position,
  quote,
  avatarSrc,
  avatarAlt,
}) => {
  return (
    <RichTextAssetBlock className={className} cssStyles={assetBlockStyle}>
      <div>
        <QuoteIcon />
        <div className="quote">{parse(quote)}</div>
      </div>
      <div>
        <div css={quoteDividerStyle} />
        <div css={authorStyle}>
          {avatarSrc && (
            <GatsbyImage
              className="with-blue-box-shadow"
              image={avatarSrc.gatsbyImageData}
              alt={avatarAlt}
              css={quoteImgStyle}
            />
          )}
          <div>
            <div className="strong-body-1">{name}</div>
            <div className="body-2">{position}</div>
          </div>
        </div>
      </div>
    </RichTextAssetBlock>
  )
}

const assetBlockStyle = css`
  // desktop only: 2 columns & need to stretch content
  @media screen and (min-width: ${breakpoints.large + 1}px) {
    display: flex;

    .quote-content-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    margin: 2rem -1.5rem !important;
  }
`

const quoteImgStyle = css`
  flex-shrink: 0;
  border-radius: 50%;
  border: 3px solid #fff;
  overflow: hidden;
  width: 3rem;
  height: 3rem;
`

// export for contentful (quote)
export const quoteDividerStyle = css`
  width: 100px;
  height: 2px;
  background-color: #318eff;
`

const authorStyle = css`
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
  column-gap: 1rem;
`
